// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 16H8.5V15H9.5V16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V11H24V23H0V11H3V1H15.4141L21 6.58594ZM1 15.002C1.00004 15.2287 1.06248 15.4609 1.19238 15.665L2.5 17.7197V21H4.5V17.7197L5.80762 15.665C5.90516 15.5118 5.96472 15.3425 5.98828 15.1719L6 15.002V13H4V14.7793L3.5 15.5654L3 14.7793V13H1V15.002ZM7.875 13C6.99435 13 6.5 13.7693 6.5 14.4287V21H8.5V18H9.5V21H11.5V14.4287C11.5 13.7693 11.0056 13 10.125 13H7.875ZM12.0713 21H14.0713V15H14.5713V21H16.5713V15H17.0713V21H19.0713V14.4287C19.0713 13.8183 18.627 13.0003 17.7148 13H12.0713V21ZM19.5 19.5713C19.5 20.3603 20.1397 21 20.9287 21H22.5V19H21.5V13H19.5V19.5713ZM14.5 7.5H19L14.5 3V7.5Z"}}]};

const FileYamlFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-yaml-filled',
    ref,
    icon: element,
  },
));

FileYamlFilledIcon.displayName = 'FileYamlFilledIcon';

export default FileYamlFilledIcon;
